export const en = {
    "choice":"Log in to your account",
    "service":"Service provider",
    "supplier":"supplier",
    "personnel":"Platform management personnel",
}

export const zh = {
    "choice":"登录您的账号",
    "service":"服务商",
    "supplier":"供应商",
    "personnel":"平台管理人员",
}